// extracted by mini-css-extract-plugin
export default {"search_card":"SearchCard_search_card__v9Glk","header":"SearchCard_header__CopwB","body":"SearchCard_body__pYEjW","footer":"SearchCard_footer__bZOik"};